import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const text =
  "Five ventures. Three businesses, two causes. One standard — show up, do the work, and make sure every person is considered.";

const Word = ({ word, range, progress }) => {
  const opacity = useTransform(progress, range, [0.15, 1]);
  return (
    <motion.span style={{ opacity }} className="mr-[0.25em] inline-block">
      {word}
    </motion.span>
  );
};

export const Statement = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.5"] });
  const words = text.split(" ");
  return (
    <section ref={ref} data-testid="statement-section" className="bg-bone px-5 py-28 text-ink md:px-10 md:py-44">
      <div className="mx-auto max-w-[1300px]">
        <p className="eyebrow mb-10 text-cobalt">The standard</p>
        <p className="font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight sm:text-5xl lg:text-7xl">
          {words.map((w, i) => (
            <Word key={i} word={w} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]} />
          ))}
        </p>
      </div>
    </section>
  );
};
